import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/Input/Select';
import { UTILIZATION_METRICS, UtilizationMetric, UtilizationMetricConfig } from './utilizationMetrics';

const METRIC_ENTRIES = (Object.entries(UTILIZATION_METRICS) as [UtilizationMetric, UtilizationMetricConfig][]).sort(
  ([, a], [, b]) => a.label.localeCompare(b.label)
);

interface UtilizationMetricSelectProps {
  value: UtilizationMetric;
  onValueChange: (value: UtilizationMetric) => void;
}

export function UtilizationMetricSelect({ value, onValueChange }: UtilizationMetricSelectProps) {
  return (
    <Select value={value} onValueChange={(v) => onValueChange(v as UtilizationMetric)}>
      <SelectTrigger size="sm">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {METRIC_ENTRIES.map(([key, config]) => (
          <SelectItem key={key} value={key}>
            {config.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
